<template>
  <div>
    <b-modal id="modalEditPaymentsMethods" ref="modalEditPaymentsMethods" :title="$t('Payments methods')" hide-footer>
      <div v-if="editItem">
        <b-form-group label-align="right" label='ID' label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input type="text" disabled v-model="editItem.id"/>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Name')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input type="text" :disabled="editItem.id < 100" v-model="editItem.name"/>
        </b-form-group>

        <modal-ok-cancel v-if="editItem.id > 99" @save="save" @cancel="$bvModal.hide('modalEditPaymentsMethods')"/>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  props: {
    editItem: null,
    isEdit: null
  },
  methods: {
    save () {
      if (!this.editItem.name) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Full name fields is invalid'), 'Error')
        return
      }

      let response = this.isEdit
        ? this.$store.dispatch('ReferenceBooks/UPDATE_PAYMENT_METHODS', this.editItem)
        : this.$store.dispatch('ReferenceBooks/CREATE_PAYMENT_METHODS', this.editItem)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          setTimeout(this.$store.dispatch, 500, 'ReferenceBooks/GET_PAYMENT_METHODS')
          this.$refs.modalEditPaymentsMethods.hide()
          this.$root.$emit('makeToasts')
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/referenceBook/paymentsMethods/editModal.vue